<template>
	<Transition name="slide-in">
		<div v-if="isVisible" class="store-overlay-panel" id="store-preview-overlay-panel">
			<slot />
		</div>
	</Transition>
</template>

<script>
	export default {
		name: 'StoreOverlayPanel',
		mounted() {},
		data() {
			return {
				isVisible: false,
			}
		},

		methods: {
			toggleVisible() {
				this.isVisible = !this.isVisible
			},
		},
	}
</script>

<style scoped>
	.store-overlay-panel {
		position: fixed;
		top: 50px; /* Leave 50px of space at the top */
		right: 0;
		width: 100%;
		height: calc(100% - 50px); /* Adjust height to not overlap the top */
		background-color: rgba(255, 255, 255, 0.8);
		backdrop-filter: blur(3px);
		z-index: 1000;
		padding: 1rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slide-in-enter-active,
	.slide-in-leave-active {
		transition: transform 0.3s ease;
	}

	.slide-in-enter {
		transform: translateX(100%);
	}

	.slide-in-leave-to {
		transform: translateX(100%);
	}
</style>
